export default class CheckoutListener {
  /**
   * @param {RedeemField} field
   * @param {AppConfig} config
   * @param {AppLibrary} library
   * @constructor
   */
  constructor (field, config, library) {
    const callback = (next) => {
      let appliedPoints = field.appliedPoints();
      let discountCheckout = field.getDiscountCheckout();
      field.removeDiscount();

      const maxPointsAmount = Math.floor(field.getMaxPriceOrig() / config.getRedeemRate());
      if (appliedPoints >= maxPointsAmount) {
        appliedPoints = maxPointsAmount;
      }

      if (!!discountCheckout) {
        field.setAppliedPoints(appliedPoints);
        Spurit.global.cartPool.getAdapter(library.appName).addFixedDiscount(field.getDiscountCheckout());
      }

      if (appliedPoints <= 0) {
        next();
        return;
      }

      try {
        const tags = config.orderTag() + ',' + config.orderTag(appliedPoints);
        Spurit.global.checkout.setTags(tags, config.snippet().appId);

        library.deleteCookie(config.getCookieNames().applied);
      } catch (e) {
        throw new Error('Error in Loyalty Points checkout callback: ' + e.message);
      }

      next();
    };

    Spurit.global.checkout.onCheckout(callback);

    config.customization().onListenerReady(this);
  }

}